import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import {selToken} from "../../../stores/base/baseSlice";
import useValidation from "../../../validation/useValidation";
import axios from "axios";
import {strings} from "../../../strings";
import {notification} from "../../functions/notification/notificationFunction";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import {ContainerHeader} from "../../module";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {initCategoryForm, onCategoryFormChange, selCategories, selCategoryForm} from "../../../stores/category/slice";
import {getCategories, getCategoriById, createCategory, editCategory} from "../../../stores/category/thunks";
import {categoryValidations} from "../../../stores/category/model";
import {uplaodFileFrom} from "../../../stores/uploader/uploadThunks";
import {styled} from "@mui/material/styles";

const Input = styled('input')({
    display: 'none',
});

export default function Category() {

    const curCategory = useSelector(selCategoryForm);
    const categories = useSelector(selCategories);
    const {
        name,
        parent_id
    } = curCategory;
    const dispatch = useDispatch();
    const {id} = useParams();
    const history = useHistory();
    const token = useSelector(selToken);

    useEffect(() => {
        dispatch(getCategories())
        id ?
         dispatch(getCategoriById(id))
         :
          dispatch(initCategoryForm())
        return () => {
            dispatch(initCategoryForm())
        }
    }, [])


    const {errors, checkFiled, checkValidation} = useValidation({
        data: categoryValidations,
        key: 'productTypeForm',
    });


    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onCategoryFormChange({name, value}))
    }

    async function create() {
        const check = await checkValidation(curCategory)
        if (!check) return dispatch(notification("error", "", <h3>برخی از فیلدها خالی هستند</h3>, false));
        const dataTable = {
            name: name,
            parent_id: parent_id,
            // description: "",
            // image: categoryImage
        }
        const formData = new FormData();
        for (let keyName in dataTable) {
            if (dataTable[keyName] !== null) {
                formData.append(keyName, dataTable[keyName]);
            }
        }
        dispatch(createCategory(formData, backToProductTypes))
    }

    async function edit() {
        const check = await checkValidation(curCategory)
        if (!check) return dispatch(notification("error", "", <h3>برخی از فیلدها خالی هستند</h3>, false));
        const dataTable = {
            name: name,
            parent_id: parent_id,
            // description: "",
            // image: categoryImage
        }
        const formData = new FormData();
        for (let keyName in dataTable) {
            if (dataTable[keyName] !== null) {
                formData.append(keyName, dataTable[keyName]);
            }
        }
        dispatch(editCategory(id, formData, backToProductTypes))
    }


    async function onDrop(event) {
        const callback = (res) => {
            dispatch(onCategoryFormChange({name: 'media', value: res}))
        }

        await Promise.all([...event.target.files]?.map((file) => {
            return dispatch(uplaodFileFrom({file}, callback))
        }))
    }

    function backToProductTypes() {
        history.push('/categories');
    }


    return (
        <Grid item xs={11} sm={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle="افزودن نوع محصول"
                backBtnTitle="بازگشت"
                backBtnAction={backToProductTypes}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper className="parentContentCreateProduct">
                <div className="w-100">
                    {/*<div className="d-flex flex-column divParentBasicInformation">*/}
                    {/*    {findContent(activeStep)}*/}
                    {/*</div>*/}
                    <div className="w-100">
                        <div className="d-flex flex-column divParentBasicInformation">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'عنوان'}
                                        variant="outlined"
                                        name={'name'}
                                        value={name}
                                        error={errors.name}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <Autocomplete
                                        id="checkboxes-tags-demo"
                                        className="w-100"
                                        size=""
                                        value={parent_id && categories.filter(x => x.id === parent_id)[0]}
                                        options={categories}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.name}
                                        onChange={(event, value) => {
                                            dispatch(onCategoryFormChange({name: 'parent_id', value: value.id}))
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params}
                                                       variant="outlined"
                                                       label="دسته بندی فرعی"
                                                       placeholder="انتخاب دسته بندی فرعی"/>
                                        )}
                                    />
                                </Grid>
                                {/*<Grid item*/}
                                {/*      lg={4} xl={4}*/}
                                {/*      className="d-flex justify-content-center align-items-center"*/}
                                {/*>*/}
                                {/*    {!media.url &&*/}
                                {/*    <label htmlFor="contained-button-file">*/}
                                {/*        <Input onChange={onDrop} id="contained-button-file" multiple*/}
                                {/*               type="file"/>*/}
                                {/*        <Button variant="contained" component="span">*/}
                                {/*            آپلود فایل*/}
                                {/*        </Button>*/}
                                {/*    </label>*/}
                                {/*    }*/}
                                {/*    {media.url &&*/}
                                {/*    <>*/}
                                {/*        <Button*/}
                                {/*            variant="contained"*/}
                                {/*            component="span"*/}
                                {/*            onClick={()=>dispatch(onCategoryFormChange({name: 'media', value: {}}))}*/}
                                {/*        >*/}
                                {/*            حذف*/}
                                {/*        </Button>*/}
                                {/*        <a href={media.url} target="_blank" className="mr-4">*/}
                                {/*            <Button variant="contained" component="span">*/}
                                {/*                نمایش*/}
                                {/*            </Button>*/}
                                {/*        </a>*/}
                                {/*    </>*/}
                                {/*    }*/}
                                {/*</Grid>*/}

                            </Grid>
                        </div>
                        <Button
                            variant="contained"
                            onClick={id ? edit : create}
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            {id ? 'ویرایش' : 'ایجاد'}
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}